// extracted by mini-css-extract-plugin
export default {"unsubscribe-all-notifications":"styles_unsubscribe-all-notifications__8k0rU","unsubscribeAllNotifications":"styles_unsubscribe-all-notifications__8k0rU"};